import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AvatarSyncService {
  private readonly _avatarUpdated = new Subject<void>();
  readonly avatarUpdated$ = this._avatarUpdated.asObservable();

  notifyAvatarUpdated(): void {
    this._avatarUpdated.next();
  }
}

